<template>
	<input autocomplete="off" :id="element.attributes.id" :style="element.styles"
		:placeholder="element.attributes.placeholder" @keyup.enter="doKeyUpAction(element)" />
</template>

<script lang="ts">
import { Container } from "@/types/customPage";
import { defineComponent, PropType } from "vue";
import { doActionHelper } from "@/utils/action";

export default defineComponent({
	props: {
		element: {
			type: Object as PropType<Container>,
			required: true,
		},
	},
	methods: {
		doAction(container: Container) {
			doActionHelper(container);
		},
		doKeyUpAction(container: Container) {
			doActionHelper(container, true)
		},
	},
});
</script>

<style scoped lang="scss"></style>
